import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux"
import { Navigate as Redirect, useLocation } from 'react-router-dom';
import ScrollBar from 'react-scrollbars-custom';
import { Helmet } from 'react-helmet-async';
import './Page.styles.scss';
import { PlatformNavigation } from "@datassential/platform-ui-lib";
import PlatformHeader from "@containers/PlatformHeader/PlatformHeader";

const PREFIX_TITLE = "Menu Trends by Datassential";

function Page({
    children,
    isWrapped = false,
    title = '',
}) {
    const location = useLocation();
    const countryCode = useSelector(state => state.countries.current);
    const [redirectLink, setRedirectLink] = useState('');

    useEffect(() => {
        if (!countryCode) setRedirectLink('/');
    }, []);

    const wrapperClass = isWrapped
        ? "wrapper"
        : "";

    return (
        <div className="Page">
            <ScrollBar
                className="Page__scroll"
                noScrollX
            >
                <PlatformNavigation className="PlatformNavigation"/>
                <PlatformHeader key={`${location.pathname}${location.search}`}/>
                <Helmet title={`${PREFIX_TITLE}${title ? ` | ${title}` : ``}`}/>
                <div className={`Page__${wrapperClass}`}>
                    {children}
                </div>
            </ScrollBar>
            {redirectLink && <Redirect to={redirectLink}/>}
        </div>
    );
}

export default Page;